import {valueType} from "../assets/js/reusableFunctions";

export default {
  startLoading(state) {
    state.loadingThreadCount += 1;
  },
  endLoading(state) {
    if (state.loadingThreadCount > 0) {
      state.loadingThreadCount -= 1;
    }
  },
  stopStart(state, need) {
    state.stopDo = true;
  },
  stopEnd(state) {
    state.stopDo = false;
  },
  setCurrentUser(state, user) {
    state.currentUser = sessionStorage.getItem('currentUser') ? sessionStorage.getItem('currentUser') : '';
    if (user) {
      state.currentUser = user;
    }
    sessionStorage.setItem('currentUser', state.currentUser);
  },
  //跨组件事件击发
  emitEvent(state, event) {
    if (event && event.name) {
      event.content = !event.content ? '' : event.content;
      event.time = new Date().getTime();
      state.eventBus.push(event);
    }
  },
  pushWebMessageIntoList(state, webMessage){
    if(webMessage){
      state.webMessageList.push(webMessage);
    }
  },
  setJobState(state, id) {
    state.jobState = sessionStorage.getItem('jobState') ? sessionStorage.getItem('jobState') : '';
    if (id) {
      state.jobState = id;
    }
    sessionStorage.setItem('jobState', state.jobState);
  },
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js